import { createRouter, createWebHistory } from "vue-router"
import { STORAGE_KEY, USER_ROLE } from "@/api/constants"

// 获取主题名称
const theme = process.env.VUE_APP_CURRENT_THEME || "default"
/**
 * 创建路由配置
 * @param {string} userRole - 用户角色
 * @returns {Array} 路由配置数组
 */
export function createRoutes(userRole = null) {
  const routes = [
    // ============ 公共路由 ============
    {
      path: "/",
      name: "Home",
      component: () =>
        import(/* webpackChunkName: "home" */ `../views/${theme}/Home.vue`),
      meta: {
        title: "home",
        nav: {
          showInNav: true,
          order: 1,
          //icon: 'home',
          submenu: {
            component: "SubmenuVerticalA"
            // items: [
            //   {
            //     name: 'Demos',
            //     links: [
            //       {
            //         location: 'https://ibid.modeltheme.com/vuejs/',
            //         name: 'Main demo',
            //         external: true,
            //         target: '_blank'
            //       },
            //       {
            //         location: 'https://ibid.modeltheme.com/vuejs/automotive/',
            //         name: 'Automotive',
            //         external: true,
            //         target: '_blank'
            //       },
            //       {
            //         location: 'https://ibid.modeltheme.com/',
            //         name: 'WordPress',
            //         external: true,
            //         target: '_blank'
            //       }
            //     ]
            //   }
            // ]
          }
        }
      }
    },
    {
      path: "/auctions",
      name: "Auctions",
      component: () =>
        import(
          /* webpackChunkName: "shop" */ `../views/${theme}/AuctionsUpcoming.vue`
        ),
      meta: {
        title: "paiMai",
        nav: {
          showInNav: true,
          order: 2,
          icon: "shopping-bag",
          submenu: {
            component: "SubmenuVerticalA",
            items: [
              {
                name: "paimai",
                links: [
                  {
                    location: "/auctions/upcoming",
                    name: "jijiangpaimai",
                    query: { category: "upcoming" }
                  }, // 添加查询参数 },
                  {
                    location: "/auctions/arts",
                    name: "jiaguopaimai",
                    query: { category: "allItem" }
                  }, // 添加查询参数 },
                  {
                    location: "/auctions/result",
                    name: "jieguopaimai",
                    query: { category: "result" }
                  }
                ]
              }
              // {
              //   name: 'Wearable',
              //   links: [
              //     { location: '/shop', name: 'Smart Watches' },
              //     { location: '/shop', name: 'Fitness Bracelets' },
              //     { location: '/shop', name: 'Masks' },
              //     { location: '/shop', name: 'Electronic tagging' }
              //   ]
              // }
            ]
          }
        }
      }
    },
    {
      path: "/auctions/upcoming",
      name: "AuctionsUpcoming",
      component: () =>
        import(
          /* webpackChunkName: "shop" */ `../views/${theme}/AuctionsUpcoming.vue`
        ),
      meta: {
        title: "即将拍卖",
        nav: {
          showInNav: false // 不在主导航显示
        }
      }
    },
    {
      path: "/auctions/arts",
      name: "AuctionsArts",
      component: () =>
        import(
          /* webpackChunkName: "shop" */ `../views/${theme}/AuctionsArts.vue`
        ),
      meta: {
        title: "即将拍卖",
        nav: {
          showInNav: false // 不在主导航显示
        }
      }
    },
    {
      path: "/auctions/result",
      name: "AuctionsResult",
      component: () =>
        import(
          /* webpackChunkName: "shop" */ `../views/${theme}/AuctionsResult.vue`
        ),
      meta: {
        title: "AuctionsResult",
        nav: {
          showInNav: false
        }
      }
    },
    {
      path: "/shop/:pageNo",
      name: "ShopWithPagination",
      component: () =>
        import(/* webpackChunkName: "shop" */ `../views/${theme}/Shop.vue`),
      meta: {
        nav: { showInNav: false } // 不在导航栏显示
      }
    },
    {
      path: "/register",
      name: "Register",
      component: () =>
        import(/* webpackChunkName: "cart" */ `../views/${theme}/Register.vue`),
      meta: {
        title: "Register",
        nav: { showInNav: false }
      }
    },
    {
      path: "/cart",
      name: "Cart",
      component: () =>
        import(/* webpackChunkName: "cart" */ `../views/${theme}/Cart.vue`),
      meta: {
        title: "Cart",
        nav: { showInNav: false } // 通常购物车不在主导航显示
      }
    },
    {
      path: process.env.VUE_APP_PRODUCT_PATH + ":productID",
      name: "Product",
      component: () =>
        import(
          /* webpackChunkName: "product" */ `../views/${theme}/Product.vue`
        ),
      meta: {
        nav: { showInNav: false }
      }
    },
    {
      path: "/lot/" + ":lotId",
      name: "Lot",
      component: () =>
        import(/* webpackChunkName: "lot" */ `../views/${theme}/Product.vue`),
      meta: {
        nav: { showInNav: false }
      }
    },
    {
      path: "/auction/" + ":auctionId",
      name: "Auction",
      component: () =>
        import(
          /* webpackChunkName: "lot" */ `../views/${theme}/AuctionDetail.vue`
        ),
      meta: {
        showFullCardInfo: true,
        nav: { showInNav: false }
      }
    },
    {
      path: "/auction/:auctionId/live",
      name: "AuctionLive",
      component: () =>
        import(
          /* webpackChunkName: "lot" */ `../views/${theme}/AuctionLive.vue`
        ),
      meta: {
        showFullCardInfo: true,
        nav: { showInNav: false }
      }
    },
    {
      path: "/news-list",
      name: "BlogList",
      component: () =>
        import(
          /* webpackChunkName: "news-list" */ `../views/${theme}/NewsList.vue`
        ),
      meta: {
        title: "News",
        nav: {
          showInNav: true,
          order: 3,
          icon: "blog",
          submenu: {
            component: "SubmenuVerticalA"
            // items: [
            //   {
            //     name: 'BLOG TYPES',
            //     links: [
            //       {
            //         location: '/blog-post/a-phone-keeps-your-friends-away-1',
            //         name: 'Blog Single'
            //       },
            //       {
            //         location: '/blog-list',
            //         name: 'Blog List'
            //       }
            //     ]
            //   }
            // ]
          }
        }
      }
    },
    {
      path: "/news-detail/" + ":newsId",
      name: "NewsDetail",
      component: () =>
        import(
          /* webpackChunkName: "news-list" */ `../views/${theme}/NewsDetail.vue`
        ),
      meta: {
        title: "News Detail",
        nav: {
          showInNav: false,
          submenu: {
            component: "SubmenuVerticalA"
            // items: [
            //   {
            //     name: 'BLOG TYPES',
            //     links: [
            //       {
            //         location: '/blog-post/a-phone-keeps-your-friends-away-1',
            //         name: 'Blog Single'
            //       },
            //       {
            //         location: '/blog-list',
            //         name: 'Blog List'
            //       }
            //     ]
            //   }
            // ]
          }
        }
      }
    },
    // {
    //   path: '/blog-list',
    //   name: 'BlogList',
    //   component: () => import(/* webpackChunkName: "blog-list" */ `../views/${theme}/BlogList.vue`),
    //   meta: {
    //     title: 'Blog',
    //     nav: {
    //       showInNav: true,
    //       order: 3,
    //       icon: 'blog',
    //       submenu: {
    //         component: 'SubmenuVerticalA',
    //         // items: [
    //         //   {
    //         //     name: 'BLOG TYPES',
    //         //     links: [
    //         //       {
    //         //         location: '/blog-post/a-phone-keeps-your-friends-away-1',
    //         //         name: 'Blog Single'
    //         //       },
    //         //       {
    //         //         location: '/blog-list',
    //         //         name: 'Blog List'
    //         //       }
    //         //     ]
    //         //   }
    //         // ]
    //       }
    //     }
    //   }
    // },
    // {
    //   path: process.env.VUE_APP_BLOG_PATH + ":blogID",
    //   name: "BlogPost",
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "blogpost" */ `../views/${theme}/BlogPost.vue`
    //     ),
    //   meta: {
    //     nav: { showInNav: false }
    //   }
    // },
    {
      path: "/about",
      name: "About",
      component: () =>
        import(/* webpackChunkName: "about" */ `../views/${theme}/About.vue`),
      meta: {
        title: "About",
        nav: {
          showInNav: true,
          order: 4,
          icon: "info-circle"
        }
      }
    },
    {
      path: "/contact",
      name: "Contact",
      component: () =>
        import(
          /* webpackChunkName: "contact" */ `../views/${theme}/Contact.vue`
        ),
      meta: {
        title: "Contact",
        nav: {
          showInNav: true,
          order: 5,
          //icon: 'envelope',
          submenu: {
            component: "SubmenuVerticalB"
          }
        }
      }
    },
    {
      path: "/login/:phone?",
      name: "Login",
      component: () =>
        import(/* webpackChunkName: "login" */ `../views/${theme}/Login.vue`),
      meta: {
        title: "Sign In",
        nav: {
          showInNav: false,
          // order: 100,
          // icon: 'sign-in-alt',
          showWhenLoggedIn: false // 登录后不显示
        }
      }
    },
    {
      path: "/admin-login",
      name: "AdminLogin",
      component: () =>
        import(
          /* webpackChunkName: "login" */ `../views/${theme}/AdminLogin.vue`
        ),
      meta: {
        title: "Admin Login",
        nav: {
          showInNav: false,
          showWhenLoggedIn: false
        }
      }
    },
    {
      path: "/my-account",
      name: "MyInfoAccount",
      component: () =>
        import(
          /* webpackChunkName: "dashboard" */ `../views/${theme}/UserHome.vue`
        ),
      meta: {
        requiresAuth: true,
        roles: [USER_ROLE.IDENTITY_CUSTOMER],
        title: "MyAccount",
        nav: {
          showInNav: false
        }
      }
    },
    {
      path: "/name-validate",
      name: "NameVlidate",
      component: () =>
        import(
          /* webpackChunkName: "dashboard" */ `../views/${theme}/NameValidate.vue`
        ),
      meta: {
        requiresAuth: true,
        roles: [USER_ROLE.IDENTITY_CUSTOMER],
        title: "NameVlidate",
        nav: {
          showInNav: false
        }
      }
    },
    {
      path: "/my-e-sign",
      name: "Esign",
      component: () =>
        import(
          /* webpackChunkName: "dashboard" */ `../views/${theme}/Esign.vue`
        ),
      meta: {
        requiresAuth: true,
        roles: [USER_ROLE.IDENTITY_CUSTOMER],
        title: "MyAccount",
        nav: {
          showInNav: false
        }
      }
    },
    {
      path: "/my-admin-account",
      name: "MyAccount",
      component: () =>
        import(
          /* webpackChunkName: "dashboard" */ `../views/${theme}/AdminHome.vue`
        )
      // meta: {
      //   requiresAuth: true,
      //   roles: [USER_ROLE.IDENTITY_ADMIN],
      //   title: 'MyAccount',
      // }
    },
    {
      path: "/live-big-screen/:auctionId",
      name: "LiveBigScreen",
      component: () =>
        import(
          /* webpackChunkName: "dashboard" */ `../components/molecules/LiveBigScreen/LiveBigScreen.vue`
        ),
      meta: {
        requiresAuth: true,
        roles: [USER_ROLE.IDENTITY_ADMIN],
        title: "LiveBigScreen",
        noRestore: true,
        nav: {
          showInNav: false
        }
      }
    },
    {
      path: "/logout",
      name: "logout",
      component: () =>
        import(
          /* webpackChunkName: "dashboard" */ `../views/${theme}/MyAccountLogout.vue`
        ),
      meta: {
        title: "logout"
      }
    },
    {
      path: "/agreement/auction-rules",
      name: "AuctionRules",
      component: () =>
        import(/* webpackChunkName: "login" */ `../views/${theme}/AuctionRulesDes.vue`),
      meta: {
        title: "拍卖规则",
        nav: {
          showInNav: false
        }
      }
    },
    {
      path: "/agreement/online-auction-rules",
      name: "AuctionOnlineRulesDes",
      component: () =>
        import(/* webpackChunkName: "login" */ `../views/${theme}/AuctionOnlineRulesDes.vue`),
      meta: {
        title: "网络拍卖规则",
        nav: {
          showInNav: false
        }
      }
    },
    {
      path: "/agreement/paddle-agreement",
      name: "PaddlePolicyDes",
      component: () =>
        import(/* webpackChunkName: "login" */ `../views/${theme}/PaddlePolicyDes.vue`),
      meta: {
        title: "号牌使用协议",
        nav: {
          showInNav: false
        }
      }
    },
    {
      path: "/agreement/delete-account-agreement",
      name: "DeleteAccountPolicy",
      component: () =>
        import(/* webpackChunkName: "login" */ `../views/${theme}/PolicyDeleteAccDes.vue`),
      meta: {
        title: "愚工拍卖账户注销须知",
        noRestore: true,
        nav: {
          showInNav: false
        }
      }
    },
  ]

  // ============ 需要登录的路由 ============
  if (userRole === "customer" || userRole === "admin") {
    routes.push({
      path: "/checkout",
      name: "Checkout",
      component: () =>
        import(
          /* webpackChunkName: "checkout" */ `../views/${theme}/Checkout.vue`
        ),
      meta: {
        requiresAuth: true,
        roles: ["customer", "admin"],
        title: "Checkout",
        nav: { showInNav: false }
      }
    })

    routes.push({
      path: "/wishlist",
      name: "Wishlist",
      component: () =>
        import(
          /* webpackChunkName: "wishlist" */ `../views/${theme}/Wishlist.vue`
        ),
      meta: {
        requiresAuth: true,
        roles: ["customer", "admin"],
        title: "Wishlist",
        nav: {
          showInNav: true,
          order: 6,
          icon: "heart",
          requiresAuth: true,
          roles: ["customer", "admin"]
        }
      }
    })

    // routes.push({
    //   path: '/my-account',
    //   name: 'MyAccount',
    //   component: () => import(/* webpackChunkName: "myaccount" */ `../views/${theme}/MyAccount.vue`),
    //   meta: {
    //     requiresAuth: true,
    //     roles: ['customer', 'admin'],
    //     title: 'My Account',
    //     nav: {
    //       showInNav: false, // 不在主导航显示，在用户下拉菜单显示
    //       icon: 'user',
    //       requiresAuth: true,
    //       roles: ['customer', 'admin']
    //     }
    //   }
    // });
  }

  // ============ 客户路由 ============
  // if (userRole === USER_ROLE.IDENTITY_CUSTOMER) {
  //   console.log('Adding IDENTITY_CUSTOMER routes for role:', userRole);
  //   routes.push({
  //     path: '/my-account',
  //     name: 'MyAccount',
  //     component: () => import(/* webpackChunkName: "dashboard" */ `../views/${theme}/UserHome.vue`),
  //     meta: {
  //       requiresAuth: true,
  //       roles: [USER_ROLE.IDENTITY_CUSTOMER],
  //       title: 'MyAccount',
  //     }
  //   });
  // }
  // ============ 管理员路由 ============
  if (userRole === "admin") {
    console.log("Adding admin routes for role:", userRole)
    routes.push({
      path: "/dashboard",
      name: "Dashboard",
      component: () =>
        import(
          /* webpackChunkName: "dashboard" */ `../views/${theme}/Dashboard.vue`
        ),
      meta: {
        requiresAuth: true,
        roles: ["admin"],
        title: "Dashboard",
        nav: {
          showInNav: true, // 在用户下拉菜单显示
          icon: "dashboard",
          requiresAuth: true,
          roles: ["admin"],
          //order: 6,
          showWhenLoggedIn: true
        }
      }
    })

    // 其他管理员路由可以根据需要添加
    // routes.push({
    //   path: '/admin/products',
    //   name: 'AdminProducts',
    //   component: () => import(/* webpackChunkName: "admin" */ `../views/${theme}/admin/Products.vue`),
    //   meta: {
    //     requiresAuth: true,
    //     roles: ['admin'],
    //     title: 'Products',
    //     nav: {
    //       showInNav: false,
    //       icon: 'box',
    //       requiresAuth: true,
    //       roles: ['admin']
    //     }
    //   }
    // });
  }

  // ============ 404 路由 ============
  routes.push({
    path: "/404",
    name: "NotFound",
    component: () => import(`../views/${theme}/NotFound.vue`),
    meta: { nav: { showInNav: false } }
  })

  routes.push({
    path: "/:catchAll(.*)",
    redirect: "/404"
  })

  return routes
}

/**
 * 创建路由实例
 * @param {string} userRole - 用户角色
 * @returns {Router} Vue Router 实例
 */
export function createRouterInstance(userRole = null) {
  const routes = createRoutes(userRole)

  return createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      }
      return { top: 0 }
    }
  })
}
